import { render, staticRenderFns } from "./RotatoryBackground.vue?vue&type=template&id=1c94a7f2&scoped=true"
import script from "./RotatoryBackground.vue?vue&type=script&lang=js"
export * from "./RotatoryBackground.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=1c94a7f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c94a7f2",
  null
  
)

export default component.exports